import { useCallback } from 'react';
import { CONVERSION_LOCATION } from 'modules/codeless-events/consts/conversionFlowConstants';
import { CONVERSION_STATUS, CONVERSION_TYPE } from 'modules/tracking/config';
import { STEP_IDS } from '../config/stepIds';
import { useConversions } from './useConversions';

export const useConversionActions = () => {
    const { setPersistentConversions, originalConversions } = useConversions();

    const isEventNew = useCallback(
        eventId => {
            return !originalConversions || !originalConversions.some(orig => orig.id === eventId);
        },
        [originalConversions]
    );

    const discardEventById = useCallback(
        eventIdToRemove => {
            if (!eventIdToRemove) return;
            setPersistentConversions(currentConversions =>
                currentConversions.filter(conv => conv.id !== eventIdToRemove)
            );
        },
        [setPersistentConversions]
    );

    const handleDeleteEvent = useCallback(
        eventId => {
            if (!eventId) return;

            if (isEventNew(eventId)) {
                discardEventById(eventId);
            } else {
                setPersistentConversions(currentConversions =>
                    currentConversions.map(conv =>
                        conv.id === eventId ? { ...conv, status: CONVERSION_STATUS.ARCHIVED } : conv
                    )
                );
            }
        },
        [setPersistentConversions, isEventNew, discardEventById]
    );

    const updateEvent = useCallback(
        (eventId, updateFn) => {
            if (!eventId) return;
            setPersistentConversions(currentConversions =>
                currentConversions.map(conv => (conv.id === eventId ? updateFn(conv) : conv))
            );
        },
        [setPersistentConversions]
    );

    const getEditTargetStepId = useCallback((eventType, event) => {
        if (eventType === CONVERSION_TYPE.EVENT_BASED) {
            if (event?.locationScope === CONVERSION_LOCATION.CROSS_SITE) {
                return STEP_IDS.BUTTON_CONVERSION_LOCATION_SELECTOR;
            }
            return STEP_IDS.BUTTON_ANALYZER_STEP;
        }
        return STEP_IDS.SETUP_URL_EVENT;
    }, []);

    return {
        handleDeleteEvent,
        isEventNew,
        updateEvent,
        discardEventById,
        getEditTargetStepId,
    };
};
